import auth from '@/app/auth/store/reducers';
import { combineReducers } from 'redux';
import fuse from './fuse';
import getstream from './getstream';

const createReducer = (asyncReducers) =>
	combineReducers({
		auth,
		fuse,
		getstream,
		...asyncReducers,
	});

export default createReducer;
